import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdminGuruMatchService, GuruMatchEntry, AlertaUsuario } from 'src/app/services/admin-gurumatch/admin-gurumatch.service';

@Component({ selector: 'app-admin-gurumatch', templateUrl: './admin-gurumatch.component.html' })
export class AdminGuruMatchComponent implements OnInit, OnDestroy {
  entries: GuruMatchEntry[] = [];
  total = 0; page = 0; size = 50; cargando = false;
  tipo = ''; buscar = '';
  stats: any = null;

  // Tabla de usuarios con alertas
  usuarios: AlertaUsuario[] = [];
  usuariosTotal = 0; usuariosPage = 0;
  filtroFrecuencia = ''; filtroPlan = '';

  // Diagnostico de la ultima ejecucion
  diagnostico: any = null;
  ejecutandoAlertas = false;
  mensajeEjecucion = '';

  constructor(private svc: AdminGuruMatchService) {}

  ngOnInit(): void {
    this.cargarHistorial();
    this.cargarUsuarios();
    this.svc.stats().subscribe(s => this.stats = s);
    this.svc.diagnostico().subscribe(d => this.diagnostico = d);
  }

  cargarHistorial(): void {
    this.cargando = true;
    this.svc.historial(this.page, this.size, this.tipo, this.buscar).subscribe({
      next: (r: any) => { this.entries = r.content; this.total = r.total; this.cargando = false; },
      error: () => this.cargando = false
    });
  }

  cargarUsuarios(): void {
    this.svc.usuarios(this.usuariosPage, 50, this.buscar, this.filtroFrecuencia, this.filtroPlan).subscribe({
      next: (r: any) => { this.usuarios = r.content; this.usuariosTotal = r.total; },
      error: () => {}
    });
  }

  filtrar(t: string): void { this.tipo = t; this.page = 0; this.cargarHistorial(); }
  onBuscar(): void { this.page = 0; this.usuariosPage = 0; this.cargarHistorial(); this.cargarUsuarios(); }
  filtrarUsuarios(): void { this.usuariosPage = 0; this.cargarUsuarios(); }
  get totalPages(): number { return Math.ceil(this.total / this.size); }
  prevPage(): void { if (this.page > 0) { this.page--; this.cargarHistorial(); } }
  nextPage(): void { if (this.page < this.totalPages - 1) { this.page++; this.cargarHistorial(); } }
  scoreColor(s: number): string { return s >= 90 ? '#059669' : s >= 70 ? '#d97706' : s >= 50 ? '#64748b' : '#dc2626'; }
  canalIcon(c: string): string { return c === 'WHATSAPP' ? 'WA' : c === 'EMAIL' ? '@' : '@'; }

  /** Agrupa las últimas alertas por candidato+minuto para mostrar un resumen por candidato */
  get alertasAgrupadas(): any[] {
    const entries: any[] = this.diagnostico?.ultimasAlertas ?? [];
    if (!entries.length) return [];
    // Agrupar por candidatoId + minuto de envío
    const groups = new Map<string, any>();
    for (const a of entries) {
      const minuto = a.sentAt ? a.sentAt.substring(0, 16) : '?';
      const key = (a.candidatoId || a.candidatoCorreo) + '|' + minuto + '|' + a.canal;
      if (!groups.has(key)) {
        groups.set(key, {
          nombre: a.candidatoNombre || a.candidatoCorreo,
          correo: a.candidatoCorreo,
          canal: a.canal,
          frecuencia: a.frecuencia,
          sentAt: a.sentAt,
          vacantes: [],
          scoreMax: 0
        });
      }
      const g = groups.get(key);
      g.vacantes.push({ titulo: a.jobTitulo, score: a.llmScore });
      if (a.llmScore > g.scoreMax) g.scoreMax = a.llmScore;
    }
    return Array.from(groups.values());
  }
  cvIcon(v: boolean): string { return v ? 'Si' : 'No'; }

  alertProcesados = 0;
  alertEnviadas = 0;
  alertFrecuencia = '';
  private pollingTimer: any = null;

  ejecutarOnDemand(): void {
    if (this.ejecutandoAlertas) return;
    this.ejecutandoAlertas = true;
    this.alertProcesados = 0;
    this.alertEnviadas = 0;
    this.alertFrecuencia = '';
    this.mensajeEjecucion = 'Iniciando ejecución on-demand (sin límites)...';

    this.svc.ejecutarAlertas().subscribe({
      next: () => {
        this.mensajeEjecucion = '';
        this.iniciarPollingAlertas();
      },
      error: (e: any) => {
        this.mensajeEjecucion = 'Error: ' + (e?.error?.error || e?.message || 'desconocido');
        this.ejecutandoAlertas = false;
      }
    });
  }

  private iniciarPollingAlertas(): void {
    if (this.pollingTimer) clearInterval(this.pollingTimer);
    this.pollingTimer = setInterval(() => {
      this.svc.alertStatus().subscribe({
        next: (s: any) => {
          const running: boolean = s?.running ?? false;
          this.alertProcesados = s?.procesados ?? 0;
          this.alertEnviadas   = s?.enviadas   ?? 0;
          this.alertFrecuencia = s?.frecuencia ?? '';

          if (!running && this.ejecutandoAlertas) {
            // Terminó — limpiar y recargar diagnóstico
            this.ejecutandoAlertas = false;
            clearInterval(this.pollingTimer);
            this.pollingTimer = null;
            this.svc.diagnostico().subscribe(d => this.diagnostico = d);
            this.cargarHistorial();
            this.cargarUsuarios();
          }
        },
        error: () => {}
      });
    }, 3000);
  }

  ngOnDestroy(): void {
    if (this.pollingTimer) clearInterval(this.pollingTimer);
  }
}
